import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteConfig } from '@/mocks/navigation';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md shadow-[0_1px_0_0_rgba(255,255,255,0.04)]'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex items-center justify-between px-4 md:px-6 py-4">
        <Link to="/" className="flex items-center gap-2.5 group cursor-pointer">
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-moon-clear-fill text-background-950 text-lg"></i>
          </div>
          <div>
            <span className="text-foreground-950 font-heading font-bold text-lg tracking-wide">
              {siteConfig.name}
            </span>
            <span className="hidden sm:block text-foreground-400 text-xs leading-none mt-0.5">
              {siteConfig.tagline}
            </span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3.5 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'bg-primary-500/15 text-primary-500'
                  : 'text-foreground-500 hover:text-foreground-800 hover:bg-background-200/50'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-500 hover:text-foreground-800 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100 border-t border-background-200/50 px-4 pb-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'bg-primary-500/15 text-primary-500'
                  : 'text-foreground-500 hover:text-foreground-800 hover:bg-background-200/50'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}